import React from "react"

interface SeparatorProps {}

function Separator() {
  return <div className="bg-[var(--selected)] kinbox:dark:bg-[var(--divider)] h-[1px] w-full my-2" />
}

export default Separator
